import type { BrandedHeadingModule } from 'types/capi/article';

type Props = {
  module: BrandedHeadingModule;
};

export function BrandedHeadingCore({ module }: Props) {
  const theme = module.theme.light;

  return (
    <>
      <div
        className="inline-flex h-8 w-fit items-center border px-2 max-md:h-7"
        style={{
          backgroundColor: theme.background,
          borderColor: theme.border,
          color: theme.foreground
        }}
      >
        <span className="text-overline">{module.highlight_text}</span>
      </div>
      <h2 className="text-title-lg">{module.heading_text}</h2>
    </>
  );
}

export default function BrandedHeading({ module }: Props) {
  return (
    <div className="content-width flex w-full items-center justify-center">
      <div className="flex w-full flex-col gap-2.5 md:gap-3">
        <BrandedHeadingCore module={module} />
      </div>
    </div>
  );
}
